import { useEffect } from 'react';

function useScrollToTop() {
    useEffect(() => { window.scroll(0, 0) }, [])
    return null
}

export default useScrollToTop